// extracted by mini-css-extract-plugin
export var active = "_58-a";
export var activeIndicator = "_58-9";
export var disabled = "_58-b";
export var fullWidth = "_58-2";
export var lg = "_58-7";
export var md = "_58-6";
export var redoButtonTabGroup = "_58-0";
export var sm = "_58-5";
export var tabButton = "_58-4";
export var tabButtonsContainer = "_58-1";
export var themeDestructive = "_58-d";
export var themeNormal = "_58-c";
export var themeSuccess = "_58-e";
export var xl = "_58-8";
export var xs = "_58-3";